import { render, staticRenderFns } from "./contextmenuItem.vue?vue&type=template&id=b1bce082&"
import script from "./contextmenuItem.vue?vue&type=script&lang=js&"
export * from "./contextmenuItem.vue?vue&type=script&lang=js&"
import style0 from "./contextmenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports